import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import PublicHolidayComponent from '../components/PublicHolidayComponent'

const mapStateToProps = (state) => {
  return {
    publicholidays: state.publicholidays,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicHolidayComponent)
